const Spinner = ({classCss}) => <div className={classCss}></div>;

export default Spinner;